<template>
    <div>
        <el-dialog :visible.sync="showmodal" width="30%">
          <div class="text-center modals-wrapper">
              <img src="../../../../../assets/images/icons/dispatch-modal-truck.png" class="mt-10 mx-auto">
              <p class="mt-10 text-lg px-1 w-2/4 mx-auto">Are you sure you want to dispatch this shipment?</p>
              <button  v-loading="loading" class="mt-12 rounded-md p-3 px-4 text-md mb-4" @click="dispatchModal">Yes, Dispatch</button>
          </div>
      </el-dialog>  
    </div>
</template>

<script>
export default {
  props: {
    showmodal: {
      type: Boolean,
      required: true,
    },
    dispatchId : {
      type : String,
      required : true
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async dispatchModal(){
        let request = {
            dispatchStatus : "dispatched",
            message : "The Shipment has been Dispatched",
            userId : this.$store.state.authentication.quantumUserId
        }

        try{
          this.loading = true

          await this.$_modifyDispatch(this.dispatchId, request)
          
          this.loading = false
          this.$emit('refetch-dispatch')
          this.$emit('close-modal')
          this.$emit('show-successful-dispatch')
        }catch(error){
          this.loading = false;
          this.handleError(error);
        }
        
    }
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
    input {
        
    }
}
</style>
